export class AnnouncementFilterCriteria {
  subject: string;
  message: string;
  fromMail: string;
  user: string;
  sentDateFrom: Date;
  sentDateTo: Date;
  uuid: any;

  constructor(userChoicesActiveFilters) {
    this.subject = userChoicesActiveFilters.subject;
    this.message = userChoicesActiveFilters.message;
    this.fromMail = userChoicesActiveFilters.fromMail;
    this.user = userChoicesActiveFilters.user;
    this.sentDateFrom = userChoicesActiveFilters.sentDateFrom;
    this.sentDateTo = userChoicesActiveFilters.sentDateTo;
    this.uuid = userChoicesActiveFilters.uuid;
  }
}
